import React, { useEffect, useState } from "react";
import { subscribeWakeStatus } from "../../services/wakeBackend";
import "./styles.scss";

const COPY = {
  starting: {
    title: "Starting Conceptor",
    body: "Servers were asleep to save energy. This usually takes under a minute — hang tight.",
  },
  ready: {
    title: "You're back online",
    body: "All set — picking up where you left off.",
  },
  failed: {
    title: "Still waking up",
    body: "This is taking longer than usual. Please refresh the page in a moment.",
  },
};

/**
 * Global overlay shown while idle-stopped API servers are waking.
 */
function WakeStatusOverlay() {
  const [status, setStatus] = useState("idle");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer;

    return subscribeWakeStatus((next) => {
      clearTimeout(hideTimer);

      if (next === "idle") {
        setVisible(false);
        setStatus("idle");
        return;
      }

      setStatus(next);
      setVisible(true);

      if (next === "ready") {
        hideTimer = setTimeout(() => {
          setVisible(false);
          setStatus("idle");
        }, 2200);
      }
    });
  }, []);

  if (!visible || status === "idle") return null;

  const copy = COPY[status] || COPY.starting;
  const isStarting = status === "starting";
  const isReady = status === "ready";
  const isFailed = status === "failed";

  return (
    <div
      className={`wake-status-overlay wake-status-overlay--${status}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="wake-status-overlay__card">
        <div className="wake-status-overlay__icon" aria-hidden="true">
          {isReady ? (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
              <path
                d="M5 13l4 4L19 7"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : isFailed ? (
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
              <path d="M12 8v5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
              <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
            </svg>
          ) : (
            <span className="wake-status-overlay__spinner" />
          )}
        </div>

        <div className="wake-status-overlay__text">
          <p className="wake-status-overlay__title">{copy.title}</p>
          <p className="wake-status-overlay__body">{copy.body}</p>
        </div>

        {isFailed && (
          <button
            type="button"
            className="wake-status-overlay__action"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        )}

        {isStarting && (
          <div className="wake-status-overlay__progress" aria-hidden="true">
            <span className="wake-status-overlay__progress-bar" />
          </div>
        )}
      </div>
    </div>
  );
}

export default WakeStatusOverlay;
